import axios from 'axios';
let baseURL = '/';
const defaultConfig = {
    baseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        Cache: 'no-cache',
    },
    withCredentials: false,
};
const axiosInstance = axios.create(defaultConfig);
// Function to setup auth interceptor
export const setupAuthInterceptor = (authService) => {
    axiosInstance.interceptors.response.use((response) => response, async (error) => {
        if (error.response?.status === 401) {
            const appPrefix = authService.getAppPrefix();
            const normalizedPrefix = appPrefix ? `_${appPrefix}` : '';
            const headersJson = localStorage.getItem(`redtrack${normalizedPrefix}_hut`);
            if (headersJson) {
                try {
                    const parsedHeaders = JSON.parse(headersJson);
                    await authService.logoutCall({
                        headers: {
                            authorization: parsedHeaders.authorization,
                            refresh: parsedHeaders.refresh,
                        },
                    });
                }
                catch (e) {
                    console.error('Error during logout:', e);
                }
            }
        }
        return Promise.reject(error);
    });
};
export default axiosInstance;
//# sourceMappingURL=axiosInstance.js.map